import React from 'react';
import './InfoButton.scss';
import axios from 'axios'
import fileDownload from 'js-file-download'
import SystemConfiguration from 'settings/SystemConfiguration';
import Images from 'constants/Images';
import * as THREE from 'three';
import { Material } from 'three';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader } from "@react-three/fiber";
import $ from "jquery";

function InfoButton(props) {

    function handleClick() {
        var menu_panel = $('#rightpanel_menu')
        var lmenu_panel = $('#leftpanel_main')
        console.log(menu_panel.is(":visible"))
        // if (menu_panel.is(":visible")) {
        //     menu_panel.hide()
        // }
        // else {
        //     menu_panel.show()
        // }
        if (menu_panel.css("visibility") == "hidden") {
            menu_panel.css("visibility", "visible")
            lmenu_panel.css("visibility", "hidden")
        }
        else {
            menu_panel.css("visibility", "hidden")
        }
    }

    const button_style = {
        visibility: window.innerWidth > 1200 ? "hidden" : "visible"
    }

    return (
        <img style={button_style} id="infobutton" src={process.env.PUBLIC_URL + Images.button_info} onClick={() => handleClick()}/>
    );

}

export default InfoButton;